import { createApp } from 'vue'
import Notifications from '@kyvg/vue3-notification'
import LineUp from '../components/team/LineUp.vue'

const teamApp = createApp({
    data() {
        return {
            tournamentType: TOURNAMENT_TYPE,
        }
    },
    methods: {
        onChangeTournamentType(type) {
            this.tournamentType = type
        },
    }
});

teamApp.component('LineUp', LineUp)
teamApp.use(Notifications)
teamApp.mount('#team')
teamApp.config.errorHandler = (error) => {
    console.error(error)
}
